import { FC } from 'react'
import { Box, FormLabel, OutlinedInput, Typography } from '@mui/material';

import styles from './CustomInput.module.scss';

type CustomInputProps = {
  required?: boolean;
  disabled?: boolean;
  inputType?: 'text' | 'email';
  inputName?: string;
  inputLabel?: string;
  error?: string;
  value?: string | null | undefined;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void | Promise<void>;
  customClass?: string;
}

const CustomInput: FC<CustomInputProps> = ({
  required = false,
  disabled = false,
  inputType = 'text',
  inputName = '',
  inputLabel ='Email',
  value = '',
  error = '', onChange,
  customClass
}) => {

  return (
    <Box id={styles.customInputContainer} className={customClass}>
      <FormLabel className={styles.customInputLabel}>
        <Typography variant='h11Semibold'>{inputLabel}</Typography>
      </FormLabel>
      <OutlinedInput
        type={inputType}
        name={inputName}
        required={required}
        disabled={disabled}
        value={value}
        className={`${!!error.length && styles.error} ${styles.customInput}`}
        placeholder={inputLabel}
        onChange={onChange}
      />
      {error && <Typography variant='h11' className={styles.errorMessage}>{error}</Typography>}
    </Box>
  )
}

export default CustomInput;
